import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded by Binit jha
       <a href="https://github.com/6202Binit/Weather_Forecast">Open sourced on Github.</a> Hosted on Netlify
    </p>
  </div>
  );
}